/**
 *
 * @description https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Regex_invalid_range_in_character_class
 * @description It takes any invalid regex with "Range out of order in character class" and escapes it
 * @param regex
 * @returns a escaped regex
 */
export default function escapeFilterRegex(regex: string) {
  return regex.replace(/\[([^\]]+)\]/g, (_, content) => {
    const escapedContent = content.replace(/[-]/g, '\\-')
    return `[${escapedContent}]`
  })
}
